package ui.screens.section.wishesandgift

import androidx.compose.foundation.Image
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import models.Wish
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.qris
import ui.theme.ColorScheme
import ui.theme.txtColor

@Composable
fun WeddingGiftImage(
    wish: Wish,
    onClickListener: () -> Unit,
) {
    Text(
        "Kado: ${wish.gift}",
        style = MaterialTheme.typography.titleSmall.copy(
            fontWeight = FontWeight.Bold,
            fontSize = 20.sp
        )
    )
    Text(
        "Silahkan Scan QRIS berikut dengan nominal yang tertera hingga 3 digit terakhir dan klik tombol Selesai agar data tersimpan",
        textAlign = TextAlign.Center,
        style = MaterialTheme.typography.titleSmall.copy(fontSize = 14.sp),
        color = txtColor
    )
    Spacer(Modifier.height(16.dp))
    Image(
        painterResource(Res.drawable.qris),
        contentDescription = "QRIS Pembayaran",
        contentScale = ContentScale.FillWidth,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .border(1.dp, Color.Gray, RoundedCornerShape(16.dp))
    )
    Spacer(Modifier.height(16.dp))
    Button(
        onClick = {
            onClickListener()
        },
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(containerColor = ColorScheme.secondary)
    ) {
        Text(
            "Selesai",
            color = Color.White,
            style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium)
        )
    }
}